class archiveRsvp {
    constructor(Alert, $http, $state, $translate) {

        this.key = 'archive-rsvp';
        this.title = 'Archive';
        this.level = 'highlight';
        this.icon = 'fal fa-trash-alt';
        this.alert = Alert;
        this.api = $http;
        this.order = 50;
        this.state = $state;
        this.translate = $translate;
    }

    action(rsvp, vm) {

        // @todo new alert, make an abstraction? reuse askToArchiveRsvp?
        const translatedValue = (path, params) => {
            return this.translate.instant(`guestlists.workflows.ask-to-archive-rsvp.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', {rsvp_name: rsvp.contact.data.full_name || rsvp.contact.data.first_name + ' ' + rsvp.contact.data.last_name}),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
                wait: true
            }).then(() => {
            return this.api.delete(`guestlists/${ vm.guestlist.id }/rsvps/${ rsvp.id }`)
                .then(() => {
                    this.state.reload();
                    if (vm.store) {
                        return vm.store.dispatch('getData');
                    }
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.guestlists')
    .factory('archiveRsvp', [
        'Alert',
        '$http',
        '$state',
        '$translate',
        (Alert, $http, $state, $translate) => new archiveRsvp(Alert, $http, $state, $translate)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/detailed/archive-rsvp.js